import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    cardHeader: {
      paddingBottom: 0,
      paddingTop: 5,
      paddingLeft: 5,
      background: colors.defaultGrey
    },
    cardFooter: {
      justifyContent: 'flex-end'
    },
    tableHeader: {
      background: colors.defaultGrey
    },
    tableInfoChip: {
      marginLeft: theme.spacing(2),
      background: colors.defaultGrey
    },
    justifyRight: {
      justifyContent: 'flex-end',
      alignItems: 'center'
    }
  });
});
